/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_MFG_OUTSTANDING_BALANCE_DISPLAY =
  'REFRESH_MFG_OUTSTANDING_BALANCE_DISPLAY';
export const GET_ERROR_MSG_MFG_OUTSTANDING_BALANCE =
  'GET_ERROR_MSG_OUTSTANDING_BAL_LABERER_QTR';
export const GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER =
  'GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER';
export const SET_SELECTED_RESULT_MFG_OUTSTANDING_BALANCE =
  'SET_SELECTED_RESULT_MFG_OUTSTANDING_BALANCE';
export const GET_OUTSTANDING_DISPUTES_QUARTER_HEADER =
  'GET_OUTSTANDING_DISPUTES_QUARTER_HEADER';
export const IS_LOADING = 'IS_LOADING';
export const SET_MANUFACTURER_OUSTANDING_BALANCE_HEADER =
  'SET_MANUFATURER_OUSTANDING_BALANCE_HEADER';
export const SET_MANUFACTURER_OUSTANDING_BALANCE_REPORT =
  'SET_MANUFACTURER_OUSTANDING_BALANCE_REPORT';
export const REFRESH_MFG_OUTSTANDING_BALANCE =
  'REFRESH_MFG_OUTSTANDING_BALANCE';
export const SELECTED_MFG_OUT_BAL_MFG = 'SELECTED_MFG_OUT_BAL_MFG';
export const EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL =
  'EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL';
export const SET_EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL =
  'SET_EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL';
export const SET_PAGINATION_INDEX_MANUFACTURER_OUSTANDING_BALANCE =
  'SET_PAGINATION_INDEX_MANUFACTURER_OUSTANDING_BALANCE';
